import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import homeLogo from "../../Assets/nishat (1)[1043].jpg";
import Type from "./Type";
import Resume from "../Resume/Resume";
import Projects from './../Projects/Projects';
import About from "../About/About";
import Services from "../Services/Services";
import LifeJourney from "../LifeJourney/LifeJourney";
//import Testimonials from './../Testimonials/Testimonials';
import AboutMe from "../AboutMe/AboutMe";
import Find from "../Find/Find";

function Home() {
  return (
    <section>
    <Container fluid className="home-section">
    <Particle />
    <Container className="home-content">
      <Row>
        <Col md={7} className="home-header">
        <span className="d-block world" style={{ color: 'rgba(198,201,216,.75)' }}>WELCOME TO MY WEBSITE</span>
          <h1 style={{ paddingBottom: 15 }} className="heading">
            Hi There! <span className="wave">👋🏻</span>
          </h1>

          <h1 className="heading-name">
            I'M
            <strong className="main-name"> Nishat Ahmed</strong>
          </h1>

          <div style={{ padding: 30, textAlign: "left" }}>
            <Type />
           </div>                                      
        </Col>

        <Col md={5} >
          <img src={homeLogo} alt="home pic" className="img-fluid" />
        </Col>
      </Row>
    </Container>
  </Container>
  
      <About></About>
      <Services></Services>
      <Projects></Projects>
      <LifeJourney></LifeJourney>
      <Resume></Resume>
       <AboutMe></AboutMe>
       <Find></Find>
</section>
    
  );
}

export default Home;
